import { styled, alpha } from "@mui/material/styles"
import { Container } from ".."

const StyledContainer = styled(Container)<{ variant?: "primary" | "secondary" }>(
  ({ theme, variant = "primary" }) => ({
    "position": "relative",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      width: 1,
      zIndex: 1,
      backgroundColor:
        variant === "primary"
          ? alpha(theme.palette["neutral.700"].main, 0.2)
          : "rgba(243, 234, 210, 0.10)",
    },
    "&::before": {
      left: "33.33%",
      [theme.breakpoints.down("md")]: {
        left: theme.spacing(3),
      },
    },
    "&::after": {
      left: "66.66%",
      [theme.breakpoints.down("md")]: {
        left: `calc(100% - ${theme.spacing(3)})`,
      },
    },
  })
)

export default StyledContainer

// rgba(243, 234, 210, 0.10)
